import { HttpResponse } from 'msw';

import { mockIsInContentAdminModeQuery } from '@sbu/views.nav/build/mocks';

export const handlers = [
  mockIsInContentAdminModeQuery(
    async ({ query: _query, variables: _variables }) => {
      return HttpResponse.json({
        data: {
          isInContentAdminMode: false,
        },
      });
    }
  ),
];
